import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import 'mobx-react-lite/batchingForReactDom';

import { ToastProvider } from '@yaydoo/react-components/lib/components/ToastWrapper/ToastContext';
import { ModalProvider } from '@yaydoo/react-components/lib/components/ModalWrapper/ModalContext';
import { DrawerProvider } from '@yaydoo/react-components/lib/components/DrawerWrapper/DrawerContext';
import theme, { oysterTheme } from '@yaydoo/react-components/lib/theme';

import store from '@store/index';
import { StoreContext } from '@hooks/useStore';

import reportWebVitals from './reportWebVitals';
import App from './containers';
import './index.css';

import initialSetup from './setup';

declare module '@material-ui/core/styles' {
  interface Theme {
    oysterTheme: typeof oysterTheme;
  }
  interface ThemeOptions {
    oysterTheme?: typeof oysterTheme;
  }
}

initialSetup();

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <StoreContext.Provider value={store}>
        <DrawerProvider>
          <ToastProvider>
            <ModalProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ModalProvider>
          </ToastProvider>
        </DrawerProvider>
      </StoreContext.Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
